export function RewindIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.5 12.866a1 1 0 000-1.732l-9-5.196a1 1 0 00-1.5.866v10.392a1 1 0 001.5.866l9-5.196zM17 7v10a1 1 0 102 0V7a1 1 0 10-2 0z"
      ></path>
    </svg>
  );
}
